module.exports = __webpack_public_path__ + "img/platform-activities-helpful-resources.ea748da6.png";